import type { ExtensionType } from '@blocksuite/store';

import { LatexBlockMarkdownAdapterExtension } from './markdown.js';

export * from './markdown.js';

export const LatexMarkdownAdapterExtensions: ExtensionType[] = [
  LatexBlockMarkdownAdapterExtension,
];
